import logo from "../images/logo.png";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { useState } from "react";
import overlay from "../images/overlay.png";
import { Link } from "react-router-dom";

const Navbar = ({work}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [navbar, setNavbar] = useState("transparent");

  const handleScroll = () => {
    setMenuOpen(false);
    if (window.scrollY >= 64) {
      setNavbar("white");
    } else {
      setNavbar("transparent");
    }
  };

  window.addEventListener("scroll", handleScroll);
  return (
    <div
      className={`navbar h-16 sm:px-16 bg-${navbar} px-8 shadow-2xl fixed top-0 right-0 left-0 z-20 `}
    >
      <div className="flex justify-between md:flex-row flex-row-reverse items-center h-full">
        <Link to={"/"}>
          <div className="">
            <img className="max-w-[100px]" src={logo} alt="" />
          </div>
        </Link>
        <div className="links ">
          <ul
            className={`md:flex ${
              menuOpen
                ? "flex flex-col absolute top-[100%] h-[calc(91vh)] w-[50%]  bg-gray-300 left-0 items-start justify-start  pl-10 py-10"
                : "hidden justify-between items-center"
            }   `}
          >
            <Link to={"/about"}>
              <li
                className={`font-bold ${
                  menuOpen ? "my-2 text-black" : "my-0"
                } text-xl ${
                  !work && navbar === "transparent" ? "text-gray-100" : "text-black"
                } mr-8 hover:text-[#FE4904] cursor-pointer`}
              >
                About us
              </li>
            </Link>
            <li
              className={`font-bold ${
                menuOpen ? "my-2 text-black" : "my-0"
              } text-xl ${
                !work && navbar === "transparent" ? "text-gray-100" : "text-black"
              } mr-8 hover:text-[#FE4904] cursor-pointer`}
            >
              Services
            </li>
            <Link to={'/work'}>
              <li
                className={`font-bold ${
                  menuOpen ? "my-2 text-black" : "my-0"
                } text-xl ${
                  !work && navbar === "transparent" ? "text-gray-100" : "text-black"
                } mr-8 hover:text-[#FE4904] cursor-pointer`}
              >
                Work
              </li>
            </Link>
            <li
              className={`font-bold ${
                menuOpen ? "my-2 text-black" : "my-0"
              } text-xl  ${
                !work && navbar === "transparent" ? "text-gray-100" : "text-black"
              } hover:text-[#FE4904] cursor-pointer`}
            >
              Contact us
            </li>
          </ul>
          {menuOpen ? (
            <AiOutlineClose
              onClick={() => setMenuOpen(false)}
              className={`md:hidden block text-3xl   ${
                !work && navbar === "transparent" ? "text-gray-100" : "text-black"
              }`}
            />
          ) : (
            <AiOutlineMenu
              onClick={() => setMenuOpen(true)}
              className={`md:hidden block text-3xl   ${
                !work && navbar === "transparent" ? "text-gray-100" : "text-black"
              }`}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default Navbar;
